import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/datumstypen/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DossierDateType"
      returnRoute="/auswahlfelder/dossierDateType"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DossierDateTypeRoute = Route;
